import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import { useAuthStore } from '../store/useAuthStore';
import PWPLogo from '../components/PWPLogo';
import styles from './Login.module.css';

export default function Login() {
    const [form, setForm] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuthStore();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const res = await authService.login(form.email, form.password);
            login(res.data.user, res.data.token);
            const role = res.data.user.role;
            navigate(role === 'region_admin' ? '/add-protest' : '/protests');
        } catch (err) {
            setError(err.response?.data?.message || 'فشل تسجيل الدخول');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={`${styles.page} text-ar`}>
            <div className={styles.card}>
                <div className={styles.brand}>
                    <PWPLogo size={72} className={styles.brandLogo} />
                    <h1>PWP Tracker</h1>
                    <p>راصد الإرادة الشعبية</p>
                </div>

                {error && <div className={styles.error}>{error}</div>}

                <form onSubmit={handleSubmit} className={styles.form}>
                    <div className={styles.field}>
                        <label className={styles.label}>البريد الإلكتروني</label>
                        <input
                            className={styles.input}
                            type="email"
                            value={form.email}
                            onChange={(e) => setForm({ ...form, email: e.target.value })}
                            placeholder="البريد الإلكتروني"
                            required
                        />
                    </div>
                    <div className={styles.field}>
                        <label className={styles.label}>كلمة المرور</label>
                        <input
                            className={styles.input}
                            type="password"
                            value={form.password}
                            onChange={(e) => setForm({ ...form, password: e.target.value })}
                            placeholder="••••••••"
                            required
                        />
                    </div>
                    <button className={styles.button} type="submit" disabled={loading}>
                        {loading ? 'جاري الدخول...' : 'تسجيل الدخول'}
                    </button>
                </form>
            </div>
        </div>
    );
}
